import { render, staticRenderFns } from "./AbnormalAttendanceSubmission.vue?vue&type=template&id=5763c1e0&scoped=true&"
import script from "./AbnormalAttendanceSubmission.vue?vue&type=script&setup=true&lang=js&"
export * from "./AbnormalAttendanceSubmission.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763c1e0",
  null
  
)

export default component.exports